import Axios, { type AxiosInstance, type AxiosPromise } from 'axios';
import ApiService from './apiService';
import type { ltCommon, ltFramework } from '@life-time-inc/enterprise-framework-core';

export const ClubNotificationServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: window.lt.api.ltApiUrl + '/aem/club-notifications/v1',
	headers: {
		'Content-Type': 'application/json; charset=UTF-8',
		apiKey: window.lt.api.apimKey
	}
});

class ClubNotificationService extends ApiService implements ltFramework.IClubNotificationService {
	constructor() {
		super('club-notification-service', ClubNotificationServiceAxiosInstance);
	}

	public getClubNotifications(id: number): AxiosPromise<ltFramework.IAlertNotification[]> {
		const config: ltCommon.IAxiosRequestConfig = {
			useJwt: true,
			params: {
				clubId: id
			}
		};
		return this.axiosInstance.get('/club', config);
	}
}

export const clubNotificationService = new ClubNotificationService();
